module.exports = __webpack_public_path__ + "img/SS_V_Basic_Dark.798e6338.png";